import { ReduxState } from "@dashboard/types/reduxState";
import { Supplier } from "@dashboard/types/supplier";

export type SupplierReducerAction =
  | {
      type: "FETCHED_SUPPLIERS";
      payload: Supplier[];
    }
  | {
      type: "DELETE_SUPPLIERS";
      payload: string[]; // Array of supplier IDs to delete
    };

export const supplierReducer: (
  state: ReduxState["supplier"] | undefined,
  action: SupplierReducerAction
) => ReduxState["supplier"] = (
  state: ReduxState["supplier"] = {
    initialSuppliersLoading: true,
    suppliers: [],
  },
  action: SupplierReducerAction
) => {
  switch (action.type) {
    case "FETCHED_SUPPLIERS":
      return {
        ...state,
        suppliers: action.payload,
        initialSuppliersLoading: false,
      };
    case "DELETE_SUPPLIERS":
      return {
        ...state,
        suppliers: state.suppliers.filter(
          (supplier) => !action.payload.includes(supplier.id)
        ),
      };
    default:
      return state;
  }
};
